import {httpService} from '@/modules/core/services/http-service';
import {Huisarts} from "@/modules/huisarts/domains";


export async function getAlleHuisartsen(): Promise<Huisarts[]> {
    const response = await httpService.get<any>(`/online-registratie/api/huisarts/all?sort=naam`)
    return response
        .map((doctorData: any) => new Huisarts(doctorData))
}
